import flatpickr from "flatpickr";

export function init(form_container) {
  form_container.querySelectorAll('.driftrock input[type="date"]').forEach(date_input => {
    date_input.addEventListener('change', on_change_native);

    const date_picker = flatpickr(date_input, {
      formatDate: date => date.toLocaleDateString(),
      onChange: on_change_flatpickr
    });

    fix_validation(date_picker);
    use_drifrock_styling(date_picker.calendarContainer);
  });
}

function on_change_flatpickr(selectedDates, dateStr, instance) {
  instance.input.removeEventListener('change', on_change_native);
  instance.input.parentNode.querySelector('input[type="hidden"]').value = to_iso8601(selectedDates[0]);
}

function on_change_native(event) {
  event.target.parentNode.querySelector('input[type="hidden"]').value = event.target.value;
}

function fix_validation(date_picker) {
  // https://github.com/flatpickr/flatpickr/issues/892
  date_picker.input.readOnly = false;
  date_picker.input.addEventListener('focus', event => event.target.readOnly = true);
  date_picker.input.addEventListener('blur', event => event.target.readOnly = false);
}

function use_drifrock_styling(node) {
  if(node) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('driftrock')
    node.parentNode.insertBefore(wrapper, node);
    node.parentNode.removeChild(node);
    wrapper.appendChild(node);
  }
}

function to_iso8601(date) {
  return date.getFullYear() +
    '-' + pad(date.getMonth() + 1) +
    '-' + pad(date.getDate());
}

function pad(number) {
  if (number < 10) {
    return '0' + number;
  }
  return number;
}
